<template>
<v-bottom-navigation flat
    :color="$store.state.config.dark ? 'secondary': 'primary'"
    
    fixed style="z-index:11"
  >
    <v-btn to="/dashboard" v-if="!checkout">
      <span>Home</span>

      <v-icon >mdi-view-dashboard-outline</v-icon>
    </v-btn>
    <v-btn to="/cart" v-if="!checkout">
      
      <v-badge
          color="green"
          :value="cartCount>0"
          :content="cartCount"
        >
      <v-icon >shopping_cart</v-icon>
      </v-badge>
    </v-btn>
    <v-spacer></v-spacer>
    
    
    <h2 class="font-weight-normal mt-2 mr-5" to="/dashboard">{{cartAmount | toCurrency}}</h2>
    
  </v-bottom-navigation>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: ['checkout'],
  data () {
    return {

      
    }
    },
 computed: {
    ...mapGetters([
      'cart', 'cartAmount', 'cartCount'
    ]),
  },
 methods: {
    ...mapActions([
      'setConfig'
    ]),
  
 }
}
</script>

